import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";

const AnnouncementItem = ({ headline, detail, showBadge = true, className = "" }) => (
  <li className={`announcement-item ${className}`}>
    <h5>
      <div className="announcement-entry">
        {showBadge && (
          <span className="announcement-badge">
            <NewGif />
          </span>
        )}
        <div className="announcement-content">
          <p className="announcement-headline">{headline}</p>
          {detail && <p className="announcement-detail">{detail}</p>}
        </div>
      </div>
    </h5>
  </li>
);

AnnouncementItem.propTypes = {
  headline: PropTypes.node.isRequired,
  detail: PropTypes.node,
  showBadge: PropTypes.bool,
  className: PropTypes.string,
};

const ServiceIconBox = ({ classOption }) => {
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <div className={`section section-padding-t50-b80 ${classOption}`}>
      <div className="container">
        <SectionTitle title="Announcement" />
        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">
            <AnnouncementItem
              className="announcement-urgent"
              headline="Urgent Notice"
              detail={
                <>
                  In accordance with notification from the State Key Laboratory of General
                  Artificial Intelligence and the Ministry of Education of the
                  People&apos;s Republic of China, ICSI&apos;2026 is required to be temporarily
                  relocated to Beijing, China. A designated liaison officer will contact each author
                  individually to confirm and update your participation arrangements. We sincerely
                  apologize for any inconvenience this may cause. Should you have any questions,
                  please contact your designated liaison officer directly. The Organizing Committee
                  will make every effort to ensure a smooth transition and provide full logistical
                  support.
                </>
              }
            />

            <AnnouncementItem
              headline="Accepted papers are proceeding through normal publication"
              detail={
                <>
                  All accepted ICSI&apos;2026 papers have entered the standard publication
                  workflow and are currently being processed for publication. Final proceedings
                  will be released on the official conference website when available. Please be
                  assured that the relocation of the conference to Beijing will have{" "}
                  <strong>no impact whatsoever</strong> on the publication of your papers.
                </>
              }
            />

            <AnnouncementItem
              headline={
                <>
                  ICSI&apos;2026{" "}
                  <Link to={`${publicUrl}/program`}>conference program</Link> is already!
                </>
              }
              detail={
                <>
                  The updated Beijing schedule — opening ceremony, plenary and invited speeches,
                  parallel technical sessions, and social events — is now available. Download the{" "}
                  <a
                    href={`${publicUrl}/files/ICSI2026_Program_Handbook.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Program Handbook (PDF)
                  </a>{" "}
                  or see the{" "}
                  <Link to={`${publicUrl}/sessions`}>detailed session timetables</Link> for
                  presentation schedules across all parallel rooms.
                </>
              }
            />

            <AnnouncementItem
              headline={
                <>
                  The <Link to={`${publicUrl}/venue`}>venue</Link> of conference is Vision Hotel
                  (唯实国际文化交流中心), Beijing!
                </>
              }
              detail={
                <>
                  On-site registration, technical sessions, meals, and social events will take
                  place at Vision International Cultural Exchange Center. Conference preferential{" "}
                  <Link to={`${publicUrl}/accommodation`}>accommodation</Link> information will be
                  announced soon for registered participants.
                </>
              }
            />

            <AnnouncementItem
              headline={
                <>
                  <Link to={`${publicUrl}/registration_pub`}>Public Registration</Link> is now open!
                </>
              }
              detail={
                <>
                  ICSI&apos;2026 warmly welcomes scholars and practitioners from around the world —
                  whether or not you have a paper — to join us in Beijing. Listen to keynote
                  speeches, attend cutting-edge research presentations, and share insights with the
                  global swarm intelligence community. Registration deadline:{" "}
                  <span className="announcement-deadline">July 18th, 2026</span>.
                </>
              }
            />

            <AnnouncementItem
              showBadge={false}
              headline={
                <>
                  Selected excellent papers will be recommended for a Special Issue of{" "}
                  <span className="announcement-deadline">
                    International Journal of Information Technology &amp; Decision Making (IJITDM)
                  </span>
                  .
                </>
              }
              detail={
                <>
                  Outstanding contributions from the conference may be invited for extended
                  publication in this prestigious journal.
                </>
              }
            />

            <div
              className="text-center mb-4"
              style={{ transform: "translate(-88px, 20px)" }}
            >
              <Link
                className="btn btn-primary btn-hover-secondary mt-s"
                to={`${publicUrl}/registration_pub`}
              >
                Public Registration
              </Link>
            </div>
          </ul>
        </div>

        <div className="space-100"></div>

        <div className="conference-ind" />
      </div>
    </div>
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
